import "./WorkflowInitializationComponent.scss";
import { useIsMobile } from "@/hooks/use-mobile";

interface WorkflowInitializationComponentProps {
    onInitializationChoice: (shouldInitialize: boolean) => void;
}

const WorkflowInitializationComponent = ({ onInitializationChoice }: WorkflowInitializationComponentProps) => {
    const isMobile = useIsMobile();

    return (
        <div className="workflow-init-container">
            <h3 className="workflow-init-title">
                Would you like to initialize a workflow?
            </h3>
            <p className="workflow-init-subtitle">
                Workflow initialization helps structure your project planning process
            </p>
            <div className="workflow-init-grid">
                {/* Yes - Initialize Workflow */}
                <button
                    onClick={() => onInitializationChoice(true)}
                    className="workflow-init-card workflow-init-card-recommended"
                >
                    <div className="recommended-tag">Recommended</div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="workflow-init-icon"
                    >
                        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
                    </svg>
                    <h4 className="workflow-init-card-title">Yes, Initialize Workflow</h4>
                    {!isMobile && (
                        <p className="workflow-init-card-description">
                            Get structured guidance through project planning and requirements
                        </p>
                    )}
                    <div className="workflow-init-badge workflow-init-badge-success">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        Better organization
                    </div>
                </button>

                {/* No - Skip Workflow */}
                <button
                    onClick={() => onInitializationChoice(false)}
                    className="workflow-init-card"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="workflow-init-icon"
                    >
                        <path d="M5 12h14" />
                        <path d="m12 5 7 7-7 7" />
                    </svg>
                    <h4 className="workflow-init-card-title">Skip for Now</h4>
                    {!isMobile && (
                        <p className="workflow-init-card-description">
                            Continue with free-form conversation
                        </p>
                    )}
                    <div className="workflow-init-badge workflow-init-badge-neutral">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" x2="12" y1="8" y2="12" />
                            <line x1="12" x2="12.01" y1="16" y2="16" />
                        </svg>
                        Less structured
                    </div>
                </button>
            </div>
        </div>
    );
};

export default WorkflowInitializationComponent;
